import { ZIP_CODE_REGEX } from './constants';

const validateFormatZipCode = zipCode => ZIP_CODE_REGEX.test(zipCode);

export default validateFormatZipCode;
